import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Integrations from "@/pages/admin/Integrations";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/integrations")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-integrations", path: "/admin/integrations", title: "Cloud Admin Integrations", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Integrations /></AdminLayout>,
});
